import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const HaishaJotai = props => {
  return <Dropdown.Static kubunKey='jotai' {...props} />
}
